import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UserDto } from '@clearing-hub/common';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UserService } from '../../../service/user.service';
import { UpdateApplicationAccessesForm } from '../../../model/UpdateApplicationAccessesForm';
import { UpdateApplicationAccessesCommand } from '@clearing-hub/command';

@Component({
  selector: 'fxch-update-application-accesses',
  templateUrl: './update-application-accesses.component.html',
  styleUrls: ['./update-application-accesses.component.scss']
})
export class UpdateApplicationAccessesComponent implements OnInit {

  form: FormGroup<UpdateApplicationAccessesForm>;
  user: UserDto;
  groups: Array<string>;

  constructor(private readonly fb: FormBuilder,
              private readonly modalRef: BsModalRef,
              private readonly userService: UserService
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      accesses: new FormControl<Array<string>>(this.user.applicationAccesses)
    });
  }

  submit() {
    if (this.form.invalid) {
      return;
    }
    const command: UpdateApplicationAccessesCommand = {
      userId: this.user.id,
      accesses: this.form.value.accesses
    }
    this.userService.updateApplicationAccesses(command).subscribe({
      next: () => {
        this.modalRef.hide();
      },
      error: (err) => {
        console.log(err);
      }
    })
  }

  close(): void {
    this.modalRef.hide();
  }
}
